import { palette } from 'c1ui'
import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const styles: moduleStyleType = {
    container: {
        p: 2,
        border: `1px solid ${palette.border.primary}`,
        borderRadius: '6px',
        backgroundColor: 'background.default',
    },
    inputGrid: {
        flexGrow: 1,
    },
}
